export enum TYPE_REPORT {
  PDF = 0,
  EXCEL = 1,
  JSON = 2,
}
